module.exports = __webpack_public_path__ + "img/logo.32fa2607.png";